import React, { useState } from 'react'
import Input from '../../components/UI/Input'
import PartnerSelect from '../../components/PartnerSelect'
import useInput from '../../hooks/input.hook'
import useAlert from '../../hooks/alert.hook'
import useAdminApi from '../../API/admin.api'

import styles from '../../styles/pages/with.module.css'



function Block() {
    const adminApi = useAdminApi()
    const Alert = useAlert()

    const [wait, setWait] = useState(false)
    const [from, setFrom] = useState(null)

    const client = useInput(null)

    const clearForm = () => { client.clear() }

    const handler = async () => {
        if(wait) { return }
        setWait(true)
        
        const res = await adminApi.blockClient(from, client.value)

        setWait(false)

        if(!res) { return }

        clearForm()
        Alert.pushMess("Client Blocked") 
    }

    const unblockhandler = async () => {
        if(wait) { return }
        setWait(true)
        
        const res = await adminApi.unblockClient(from, client.value)

        setWait(false)

        if(!res) { return }

        clearForm()
        Alert.pushMess("Client UnBlocked") 
    }

    return (
        <div className={styles.main}>
        <div className={styles.form}>
            <h3>From:</h3>
            <PartnerSelect handler={(partner) => setFrom(partner.value)}/>
            <h3>Client Id: </h3>
            <Input input={client} placeholder='client Id'/>

            <button className={styles.button} onClick={() => handler()}>Block</button>
            <button className={styles.button} onClick={() => unblockhandler()}>UnBlock</button>
        </div>
        </div>
    )
}

export default Block